import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';
import { api } from '../lib/api';

interface ModeContextType {
  registrationEnabled: boolean;
  toggleRegistration: (enabled: boolean) => Promise<void>;
  syncRegistration: (enabled: boolean) => void;
}

const ModeContext = createContext<ModeContextType | null>(null);

export function ModeProvider({ children }: { children: ReactNode }) {
  const [registrationEnabled, setRegistrationEnabled] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetch = () => {
      api.config.getRegistrationMode().then((res) => {
        if (!cancelled) setRegistrationEnabled(res.enabled);
      }).catch(() => {});
    };
    fetch();
    const id = setInterval(fetch, 30000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  const toggleRegistration = async (enabled: boolean) => {
    await api.config.setRegistrationMode(enabled);
    setRegistrationEnabled(enabled);
  };

  const syncRegistration = (enabled: boolean) => {
    setRegistrationEnabled(enabled);
  };

  return (
    <ModeContext.Provider value={{ registrationEnabled, toggleRegistration, syncRegistration }}>
      {children}
    </ModeContext.Provider>
  );
}

export function useMode() {
  const ctx = useContext(ModeContext);
  if (!ctx) throw new Error('useMode must be used within ModeProvider');
  return ctx;
}
